import { createAction, props } from '@ngrx/store';
import { PnpBudget } from '../../models/pnp-budget.model';

export const fetchPnpBudgets = createAction(
  '[PnpBudget] Fetch Budgets'
);

export const fetchPnpBudgetsSuccess = createAction(
  '[PnpBudget API] Fetch Budgets Success',
  props<{ budgets: PnpBudget[] }>()
);

export const fetchPnpBudgetsFailure = createAction(
  '[PnpBudget API] Fetch Budgets Failure'
);

export const fetchPnpBudgetsForOrder = createAction(
  '[PnpBudget] Fetch Budgets For Order',
  props<{ orderId: number }>()
);

export const fetchPnpBudgetsForOrderSuccess = createAction(
  '[PnpBudget API] Fetch Budgets For Order Success',
  props<{ orderId: number; budgets: PnpBudget[] }>()
);

export const fetchPnpBudgetsForOrderFailure = createAction(
  '[PnpBudget API] Fetch Budgets For Order Failure',
  props<{ orderId: number }>()
);

export const resetPnpBudgetsForOrder = createAction(
  '[PnpBudget API] Reset Budgets For Order',
  props<{ orderId: number}>()
);

export const fetchBudgetAvailable = createAction(
  '[PnpBudget] Fetch Budget Available',
  props<{ orderId: number }>()
);

export const fetchBudgetAvailableSuccess = createAction(
  '[PnpBudget API] Fetch Budget Available Success',
  props<{ orderId: number; available: boolean }>()
);

export const fetchBudgetAvailableFailure = createAction(
  '[PnpBudget API] Fetch Budget Available Failure',
  props<{ orderId: number }>()
);

export const resetBudgetAvailable = createAction(
  '[PnpBudget API] Reset Budget Available',
  props<{ orderId: number }>()
);

export const setPnpBudgetsForOrder = createAction(
  '[PnpBudget] Set Budgets For Order',
  props<{ orderId: number; budgets: PnpBudget[] }>()
);

